import { useState, useEffect } from "react";
import ItemList from "./ItemList";
import { db } from "../FireBase";
import { getDocs, collection } from "firebase/firestore";

const ItemListContainer = () => {

    const [triplesSimples, setTriplesSimples] = useState([]);
    const [triplesSurtidos, setTriplesSurtidos] = useState([]);
    const [triplesEspeciales, setTriplesEspeciales] = useState([]);
    const [tortas, setTortas] = useState([]);
    const [chipa, setChipa] = useState([]);



    useEffect(() => {

        const triplesSimples = collection(db, "simples");
        const documentosTriplesSimples = getDocs(triplesSimples);

        documentosTriplesSimples
            .then((res) => {

                const aux = [];

                res.forEach((documento) => {
                    const producto = {
                        id: documento.id,
                        ...documento.data()
                    }
                    aux.push(producto);
                })
                setTriplesSimples(aux)
            })

        const especiales = collection(db, "triplessurtidos");
        const documentosEspeciales = getDocs(especiales);

        documentosEspeciales
            .then((res) => {

                const aux = [];

                res.forEach((documento) => {
                    const producto = {
                        id: documento.id,
                        ...documento.data()
                    }
                    aux.push(producto);
                })
                setTriplesSurtidos(aux)
            })

        const triplesespeciales = collection(db, "triplesespeciales");
        const documentosTriplesEspeciales = getDocs(triplesespeciales);

        documentosTriplesEspeciales
            .then((res) => {

                const aux = [];

                res.forEach((documento) => {
                    const producto = {
                        id: documento.id,
                        ...documento.data()
                    }
                    aux.push(producto);
                })
                setTriplesEspeciales(aux)
            })

        const tortas = collection(db, "tortas");
        const documentosTortas = getDocs(tortas);

        documentosTortas
            .then((res) => {

                const aux = [];

                res.forEach((documento) => {
                    const producto = {
                        id: documento.id,
                        ...documento.data()
                    }
                    aux.push(producto);
                })
                setTortas(aux)
            })

        const chipas = collection(db, "chipa");
        const documentosChipas = getDocs(chipas);

        documentosChipas
            .then((res) => {

                const aux = [];

                res.forEach((documento) => {
                    const producto = {
                        id: documento.id,
                        ...documento.data()
                    }
                    aux.push(producto);
                })
                setChipa(aux)
            })
            .catch(() => {
                console.log("ERROR");
            })
    }, [])

    return (
        <>
            <section className="prueba" id="TriplesJQ">
                <h2 className="category-title">Triples con Jamon y Queso</h2>
                <ItemList items={triplesSimples} />
            </section>
            <section className="prueba" id="TriplesSurtidos">
                <h2 className="category-title">Triples Surtidos</h2>
                <ItemList items={triplesSurtidos} />
            </section>
            <section className="prueba" id="TriplesEspeciales">
                <h2 className="category-title">Triples Especiales</h2>
                <ItemList items={triplesEspeciales} />
            </section>
            <section className="prueba" id="TortasMiga">
                <h2 className="category-title">Tortas de Miga</h2>
                <ItemList items={tortas} />
            </section>
            <section className="prueba" id="Chipa" style={{
                paddingBottom: "60px"
            }}>
                <h2 className="category-title">Chipa</h2>
                <ItemList items={chipa} />
            </section>

        </>
    )
}

export default ItemListContainer;

/*

<section className="prueba" id="projects">
                <h1 >Especiales</h1>
                <ItemList items={producto2} />
            </section>
            <section className="prueba" id="blog">
                <h1 >Tortas</h1>
                <ItemList items={producto2} />
            </section>
            <section className="prueba" id="contact">
                <h1 >Chipa</h1>
                <ItemList items={producto2} />
                <ItemList items={producto2} />
            </section>



            
const ItemListContainer = () => {


    return (
        <div className="item-list-container ">

            <section className="prueba prueba2" id="about">Simples</section>

            <section className="prueba" id="projects">Especiales</section>

            <section className="prueba prueba2" id="blog">Tortas</section>

            <section className="prueba" id="contact">Chipa</section>
        </div>
    );
    /*<section className="prueba" id="about">ABOUT</section>
            <section className="prueba" id="projects">PROJECTS</section>
            <section className="prueba" id="blog">BLOG</section>
            <section className="prueba" id="contact">CONTACT ME</section>
}


export default ItemListContainer;*/